/**
 * Serializa la query de un listado v2 (ADR 0020) a bracket notation:
 * `filters[campo][$op]=valor`, con claves repetidas para operadores multi-valor
 * (`$in`/`$nin`) e índices numéricos para los combinadores lógicos (`$or`/`$and`).
 *
 * Reemplaza al `querySerializer` por defecto del SDK generado, que usa estilo
 * `deepObject` de UN SOLO nivel: al toparse con un filtro anidado
 * (`{ fullName: { $contains: 'x' } }`) llama a `serializePrimitiveParam` con un
 * objeto y tira "Deeply-nested arrays/objects aren't supported". Con este
 * serializer, cualquier listado v2 (users, roles, …) manda los filtros ricos
 * bien formados.
 *
 * Espeja el enfoque probado de `buildListQueryString` (v1): `URLSearchParams`
 * con claves con corchetes, que el parser `qs` de Express reconstruye del lado
 * del backend (`filters[a][$eq]=1` → `{ filters: { a: { $eq: '1' } } }`).
 */
function appendNested(search: URLSearchParams, prefix: string, value: unknown): void {
  if (value === undefined || value === null || value === '') return

  if (Array.isArray(value)) {
    value.forEach((item, index) => {
      if (item !== null && typeof item === 'object') {
        // Array de objetos → combinador lógico ($or/$and): índice numérico.
        appendNested(search, `${prefix}[${index}]`, item)
      } else {
        // Array de primitivos → operador multi-valor ($in/$nin): clave repetida.
        appendNested(search, prefix, item)
      }
    })
    return
  }

  if (typeof value === 'object') {
    for (const [key, nested] of Object.entries(value as Record<string, unknown>)) {
      appendNested(search, `${prefix}[${key}]`, nested)
    }
    return
  }

  search.append(prefix, String(value))
}

export function serializeV2ListQuery(query: Record<string, unknown>): string {
  const search = new URLSearchParams()
  for (const [key, value] of Object.entries(query)) {
    appendNested(search, key, value)
  }
  return search.toString()
}
